import actions from "./actions";

const initState = {
    currencyReadExchangeRateState: false,
    currencyReadExchangeRateResult: undefined,
    currencyRate: false,

    currencies: [],
    activateCurrencyStatus: false,
    archiveCurrencyStatus: false,
    readCurrencyRateStatus: false,

    readCurrencyRatesStatus: false,
    currencyRates: [],
    pagination: {},

    createCurrencyRateState: false,
    currencyRateInfo: {},
    isEditCurrencyRate: false,

    updateCurrencyRateState: false,
    deletCurrencyRateState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_CURRENCIES_SUCCESS:
            return {
                ...state,
                currencies: action.currencies,
            };
        case actions.ACTIVATE_CURRENCY_REQUEST:
            return {
                ...state,
                activateCurrencyStatus: 'request',
            };
        case actions.ACTIVATE_CURRENCY_SUCCESS:
            return {
                ...state,
                activateCurrencyStatus: 'success',
            };
        case actions.ARCHIVE_CURRENCY_REQUEST:
            return {
                ...state,
                archiveCurrencyStatus: 'request',
            };
        case actions.ARCHIVE_CURRENCY_SUCCESS:
            return {
                ...state,
                archiveCurrencyStatus: 'success',
            };
        case actions.READ_CURRENCY_RATE_REQUEST:
            return {
                ...state,
                readCurrencyRateStatus: 'request',
                currencyReadExchangeRateState: 'request',
            };
        case actions.READ_CURRENCY_RATE_SUCCESS:
            return {
                ...state,
                currencyRate: action.currencyRate,
                readCurrencyRateStatus: 'success',
                currencyReadExchangeRateState: 'success',
                currencyReadExchangeRateResult: action.currencyRate,
            };
        case actions.RESET_CURRENCY:
            return {
                ...state,
                currencyReadExchangeRateState: initState.currencyReadExchangeRateState,
                currencyReadExchangeRateResult: initState.currencyReadExchangeRateResult,
                currencyRate: initState.currencyRate,
                readCurrencyRateStatus: initState.readCurrencyRateStatus,
            };

        case actions.READ_CURRENCY_RATES_REQUEST:
            return {
                ...state,
                readCurrencyRatesStatus: 'request',
            };
        case actions.READ_CURRENCY_RATES_SUCCESS:
            return {
                ...state,
                readCurrencyRatesStatus: 'success',
                currencyRates: action.currencyRates,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.READ_CURRENCY_RATES_ERROR:
            return {
                ...state,
                readCurrencyRatesStatus: 'error',
                currencyRates: initState.currencyRates,
            };
        case actions.CREATE_CURRENCY_RATE_REQUEST:
            return {
                ...state,
                createCurrencyRateState: 'request',
            };
        case actions.CREATE_CURRENCY_RATE_SUCCESS:
            return {
                ...state,
                createCurrencyRateState: 'success',
                currencyRateInfo: action.currencyRateInfo,
            };
        case actions.UPDATE_CURRENCY_RATE_REQUEST:
            return {
                ...state,
                updateCurrencyRateState: 'request',
            };
        case actions.UPDATE_CURRENCY_RATE_SUCCESS:
            return {
                ...state,
                updateCurrencyRateState: 'success',
                // currencyRateInfo: action.request,
            };
        case actions.DELETE_CURRENCY_RATE_REQUEST:
            return {
                ...state,
                deleteCurrencyRateState: 'request',
            };
        case actions.DELETE_CURRENCY_RATE_SUCCESS:
            return {
                ...state,
                deleteCurrencyRateState: 'success',
            };
        case actions.SET_CURRENCY_RATE:
            return {
                ...state,
                currencyRateInfo: action.currencyRateInfo,
                isEditCurrencyRate: action.isEditMode,
            };
        default:
            return state;
    }
}
